import { Routing } from 'routing'
import { RecoilRoot } from 'recoil'

export const App = () => {
  return (
    <RecoilRoot>
      <Routing />
    </RecoilRoot>
  )
}
